<template lang="pug">
#operacoes-cda-wa
    BaseHeader(
        titulo='Operação CDA-WA',
        icon='el-icon-circle-plus-outline',
        btnTexto='Nova operação',
        :exibeBotao='exibirBotaoNovaOperacao',
        @btnHeaderClicado='irParaNovaOperacao'
    )

    .view-container-base-header
        Filtros(@filtrar='filtrar')

        .totalizadores.mt-20
            el-card(:body-style='{ padding: "10px" }')
                .totalizadores__informacao
                    i.lyra-icon.lyra-transfer
                    h2 Número de Operações:
                    h2 {{ totalizadores.numOperacoes }}

            el-card(:body-style='{ padding: "10px" }')
                .totalizadores__informacao
                    i.lyra-icon.lyra-grafico-2
                    h2 Volume
                el-carousel.totalizador_culturas(
                    height='20px',
                    trigger='click',
                    indicator-position='outside',
                    arrow='never',
                    :interval='3000'
                )
                    el-carousel-item.totalizador_culturas_item(
                        v-for='(volume, index) in totalizadores.volumes',
                        :key='index'
                    )
                        h3 {{ volume.cultura + ':' }}
                        h3 {{ volume.valorFormatado }}

            el-card(:body-style='{ padding: "10px" }')
                .totalizadores__informacao
                    i.lyra-icon.lyra-marcador
                    h2 Número de Imóveis:
                    h2 {{ totalizadores.numImoveis }}

            el-tooltip(
                effect='dark',
                :content='tooltipOperacoesAlerta()',
                placement='top'
            )
                el-card.totalizadores__informacao--operacoes(
                    :body-style='{ padding: "10px" }'
                )
                    .totalizadores__informacao(
                        @click='filtrarOperacoesAlerta()'
                    )
                        i.flow.flow-warning-sign
                        h2 Operações com Alerta:
                        h2 {{ totalizadores.operacoesAlerta }}

        section.lista-operacao-cda-wa__tabela.mt-20
            el-table(
                :data='operacoes',
                stripe,
                v-loading='buscandoOperacoes',
                element-loading-text='Buscando operaçoes...',
                @sort-change='sortChangeRequest'
            )
                el-table-column(label='Identificador', minWidth='120px')
                    .template(slot-scope='scope')
                        em.badge.badge-secondary {{ scope.row.identificador }}
                        span.alerta(
                            v-if='scope.row.possuiAlerta',
                            style='word-break: normal'
                        )
                            | Alerta

                el-table-column(label='Operação', minWidth='145px')
                    .template(slot-scope='scope')
                        span.column_text {{ scope.row.descricao }}
                el-table-column(prop='safra', label='Safra', minWidth='95px')
                el-table-column(
                    prop='cultura',
                    label='Cultura',
                    minWidth='95px',
                    sortable='custom'
                )
                el-table-column(
                    prop='volumeContratado',
                    label='Volume',
                    minWidth='105px',
                    sortable='custom'
                )
                el-table-column(prop='valor', label='Valor', minWidth='100px')
                el-table-column(label='Fornecedor', minWidth='160px')
                    .template(slot-scope='scope')
                        span.column_text {{ scope.row.fornecedorNome }}
                el-table-column(
                    prop='dataContrato',
                    label='Data do contrato',
                    minWidth='156px',
                    sortable='custom'
                )
                el-table-column(
                    prop='dataVencimento',
                    label='Vencimento',
                    minWidth='123px',
                    sortable='custom'
                )
                el-table-column(
                    label='Status',
                    align='center',
                    minWidth='123px'
                )
                    template(slot-scope='scope')
                        span(:class='["tag", tratarStatus(scope.row.status)]') {{ scope.row.status ? scope.row.status : '--' }}

                el-table-column(label='Observação', minWidth='140px')
                    .template(slot-scope='scope')
                        span.column_text(
                            :title='scope.row.observacao.length > 40 ? scope.row.observacao : null'
                        )
                            | {{ scope.row.observacao.length > 40 ? scope.row.observacao.substring(0, 40) + '...' : scope.row.observacao }}
                el-table-column(label='Ações', align='center', minWidth='70px')
                    .template(slot-scope='scope')
                        el-dropdown.action-button
                            i.mdi.mdi-dots-vertical

                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='visualizarOperacao(scope.row)'
                                ) Visualizar operação

                                div(
                                    v-if='usuarioLogado.operacaoCdaWaAprovador && scope.row.status === "Processado"'
                                )
                                    el-dropdown-item(
                                        icon='el-icon-check',
                                        @click.native='confirmarAcao(scope.row, true)'
                                    ) Aprovar operação

                                    el-dropdown-item(
                                        icon='el-icon-circle-close',
                                        @click.native='confirmarAcao(scope.row, false)'
                                    ) Reprovar operação
                                div(
                                    v-if='usuarioLogado.operacaoCdaWaCadastrante && scope.row.status === "Aprovado"'
                                )
                                    el-dropdown-item(
                                        icon='el-icon-monitor',
                                        @click.native='visualizarMonitoramento(scope.row)'
                                    ) Monitoramento
                                el-dropdown-item(
                                    icon='el-icon-download',
                                    @click.native='exportarAnalisePdf(scope.row)',
                                    v-if='scope.row.status !== "Em processamento"'
                                ) Exportar relatório

                                div(
                                    v-if='usuarioLogado.operacaoCdaWaAprovador || usuarioLogado.operacaoCdaWaCadastrante'
                                )
                                    el-dropdown-item(
                                        icon='el-icon-download',
                                        @click.native='exportarAnaliseExcel(scope.row)'
                                    ) Exportar em Excel

                template(slot='empty')
                    el-empty(description='Sem dados')
            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ totalOperacoes }} operações

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.size',
                        :current-page.sync='paginacao.page',
                        layout='prev, pager, next',
                        :total='totalOperacoes',
                        @current-change='alterarPagina'
                    )

    modal-confirmar-aprovar-reprovar-operacao-cda-wa(
        :show='payloadModalConfirmar.mostrar',
        :identificador='payloadModalConfirmar.identificador',
        :aprovar='payloadModalConfirmar.aprovar',
        @fechar='payloadModalConfirmar.mostrar = false',
        @acao='payloadModalConfirmar.aprovar ? aprovarOperacao() : reprovarOperacao()'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import { mapGetters } from 'vuex';
import ModalConfirmarAprovarReprovarOperacaoCdaWa from '@/components/operacao-cda-wa/ModalConfirmarAprovarReprovarOperacaoCdaWa.vue';
import Filtros from '@/components/operacao-cda-wa/Filtros.vue';

export default {
    name: 'OperacoesCdaWa',
    components: {
        ModalConfirmarAprovarReprovarOperacaoCdaWa,
        BaseHeader,
        Filtros
    },
    data() {
        return {
            buscandoFiltrosStatus: false,
            status: [],
            payloadModalConfirmar: {
                mostrar: false,
                aprovar: false,
                payload: null
            },
            filtroAberto: '',
            filtroPesquisa: '',
            operacoes: [],
            totalOperacoes: 0,
            buscandoOperacoes: false,
            paginacao: {
                page: 1,
                size: 10,
                sort: ''
            },
            order: null,
            nomeColumn: null,
            exibirBotaoNovaOperacao: false,
            filtros: {},
            filtroStatus: '',
            totalizadores: {}
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.informacoesIniciais();
    },
    methods: {
        async informacoesIniciais() {
            await this.buscarTotalizadores();
            await this.buscarOperacoes();
            this.exibirBotaoNovaOperacao =
                this.usuarioLogado.operacaoCdaWaCadastrante;
        },

        async aprovarOperacao() {
            await OperacaoCdaWaService.aprovarOperacao(
                this.payloadModalConfirmar.payload
            )
                .then(() => {
                    this.informacoesIniciais();
                    this.$notify.success({
                        message: 'Operação aprovada com sucesso.'
                    });
                })
                .catch(rsp => {
                    if (rsp.response?.data?.message) {
                        this.$notify.error({
                            message: rsp.response?.data?.message
                        });
                    } else {
                        this.$notify.error({
                            message: 'Não foi aprovar a operação.'
                        });
                    }
                })
                .finally(() => {
                    this.payloadModalConfirmar.mostrar = false;
                });
        },

        confirmarAcao({ identificador, id }, ehAprovacao) {
            this.payloadModalConfirmar.aprovar = ehAprovacao;
            this.payloadModalConfirmar.payload = id;
            this.payloadModalConfirmar.identificador = identificador;
            this.payloadModalConfirmar.mostrar = true;
        },

        async reprovarOperacao() {
            await OperacaoCdaWaService.reprovarOperacao(
                this.payloadModalConfirmar.payload
            )
                .then(() => {
                    this.buscarOperacoes();
                    this.$notify.success({
                        message: 'Operação reprovada com sucesso.'
                    });
                })
                .catch(rsp => {
                    if (rsp.response?.data?.message) {
                        this.$notify.error({
                            message: rsp.response?.data?.message
                        });
                    } else {
                        this.$notify.error({
                            message: 'Não foi reprovar a operação.'
                        });
                    }
                })
                .finally(() => {
                    this.payloadModalConfirmar.mostrar = false;
                });
        },

        filtrarOperacoesAlerta() {
            this.filtros.possuiAlerta = !this.filtros.possuiAlerta;
            this.filtrar(this.filtros);
        },

        tooltipOperacoesAlerta() {
            if (this.filtros.possuiAlerta) {
                return 'Exibir todas as operações';
            } else {
                return 'Exibir operações com alerta';
            }
        },

        async buscarOperacoes() {
            this.buscandoOperacoes = true;

            if (!this.order) {
                this.paginacao.sort = '&sort=data_cadastro,asc';
            }

            try {
                const { data } = await OperacaoCdaWaService.buscarOperacoes(
                    this.filtros,
                    this.paginacao
                );
                const { itens, totalItens } = data;

                this.operacoes = itens;
                this.totalOperacoes = totalItens;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar as operações.'
                });
            } finally {
                this.buscandoOperacoes = false;
            }
        },

        alterarPagina(pagina) {
            this.paginacao.page = pagina;
            this.buscarOperacoes();
        },

        irParaNovaOperacao() {
            this.$router.push({ name: 'NovaOperacaoCdaWa' });
        },

        visualizarOperacao({ id }) {
            this.$router.push({
                name: 'VisualizarOperacaoCdaWa',
                params: { idOperacao: id }
            });
        },

        async exportarAnalisePdf({ id }) {
            try {
                await OperacaoCdaWaService.exportarAnalisePdf(id);

                this.$notify.success({
                    message: 'Análise exportada com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao exportar a análise!'
                });
            }
        },
        visualizarMonitoramento(operacao) {
            this.$router.push({
                name: 'operacaoMonitoramentoCdaWa',
                params: { idOperacao: operacao.id }
            });
        },

        async exportarAnaliseExcel({ id }) {
            try {
                await OperacaoCdaWaService.exportarAnaliseExcel(id);

                this.$notify.success({
                    message: 'Download realizado com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar download!'
                });
            }
        },

        async filtrar(filtros) {
            this.filtros = filtros;
            this.paginacao = {
                page: 1,
                size: 10,
                sort: ''
            };
            this.buscarOperacoes();
            this.buscarTotalizadores();
        },

        async buscarTotalizadores() {
            const { data } = await OperacaoCdaWaService.buscarTotalizadores({
                ...this.filtros
            });
            this.totalizadores = data;
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }

            this.nomeColumn = column.prop;
            this.fetchOperacoes();
        },

        async fetchOperacoes() {
            let filtro = this.getFiltros();
            this.paginacao.sort = filtro.order;

            this.buscarOperacoes();
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.size;
            filtro.page = this.paginacao.page - 1;

            filtro.order = '&sort=data_cadastro,asc';

            if (this.order && this.nomeColumn) {
                const nomesColunas = {
                    status: 'status',
                    cultura: 'nome_cultura',
                    dataVencimento: 'data_vencimento',
                    dataContrato: 'data_contrato',
                    volumeContratado: 'volume_contratado'
                };
                const sort = nomesColunas[this.nomeColumn];
                filtro.order = `&sort=${sort},${this.order}`;
            }
            return filtro;
        },
        tratarStatus(status) {
            if (status === 'Em Cadastramento') {
                return 'em-cadastramento';
            } else if (status === 'Em processamento') {
                return 'em-processamento';
            } else {
                return status.toLowerCase();
            }
        }
    }
};
</script>

<style lang="scss">
#el-table {
    width: 2000px;
}

#operacoes-cda-wa {
    .lista-operacao-cda-wa__filtros {
        height: 50px;
        margin-bottom: 20px;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .lista-operacao-cda-wa__tabela {
        border-radius: 5px;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            width: 100%;
        }

        .el-table .cell:only-child {
            padding-left: 10px;
        }

        .el-table th {
            font-weight: bold;
            font-size: 14px;
            :only-child {
                padding-left: 20px;
            }
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            margin-top: 8px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }

        em.lista-operacao-cda-wa__tabela__identificador {
            font-style: normal;
            background-color: var(--secondary);
            padding: 2px 4px;
            border-radius: 4px;
            font-weight: 600;
            color: black !important;
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }

        .tag {
            border-radius: 5px;
            text-align: center;
            font-size: 11px;
            font-weight: 500;
            padding: 3px;
        }

        .aprovado {
            border: 1px solid var(--tag-success-border);
            background-color: var(--tag-success-background);
            color: var(--tag-success-text);
        }

        .reprovado, .vencido {
            border: 1px solid var(--tag-danger-border);
            background-color: var(--tag-danger-background);
            color: var(--tag-danger-text);
        }

        .processando {
            border: 1px solid var(--tag-gray-border);
            background-color: var(--tag-gray-background);
            color: var(--tag-gray-text);
        }

        .em-processamento {
            border: 1px solid var(--tag-danger-border);
            background-color: var(--tag-danger-background);
            color: var(--tag-danger-text);
        }

        .em-cadastramento {
            border: 1px solid var(--tag-gray-border);
            background-color: var(--tag-gray-background);
            color: var(--tag-gray-text);
        }

        .processado {
            border: 1px solid var(--tag-warning-border);
            background-color: var(--tag-warning-background);
            color: var(--tag-warning-text);
        }
    }

    .mt-20 {
        margin-top: 20px;
    }

    .cards {
        display: flex;
        height: 120px;
        gap: 14px;

        .el-card {
            flex: 1;
        }
    }
    .contanier {
        margin: 20px;
    }

    .filter-icon {
        display: flex;
        align-items: center;
        padding-left: 15px;
    }

    .totalizadores {
        display: flex;
        gap: 10px;

        .el-card {
            flex: 1;

            display: grid;
            place-items: center;
        }

        .totalizadores__informacao,
        .totalizadores__informacao--volume {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            color: var(--primary);

            .lyra-icon::before {
                background-color: var(--primary);
            }
        }

        .flow-warning-sign {
            font-size: x-large;
            font-weight: bold;
        }

        .totalizadores__informacao--operacoes:hover {
            cursor: pointer;
        }

        .totalizadores__informacao--volume {
            justify-content: space-evenly;
            border-radius: 2px;
            transition: all 0.3s ease-in-out;

            h3 {
                padding: 4px 0;
                width: 115px;
            }

            h3:nth-of-type(2) {
                text-align: right;
            }
        }

        .totalizadores__informacao--volume:hover {
            background-color: var(--default-border-color);
        }

        .totalizador_culturas {
            min-width: 250px;
        }

        .totalizador_culturas_item {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            width: 100%;
            height: 30px;
            background-color: white;
        }

        .totalizador_culturas_item:hover {
            background-color: var(--default-border-color);
        }
    }

    .el-pagination {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
}

.column_text {
    word-break: keep-all;
}

.badge.badge-secondary {
    white-space: normal !important;
    word-break: normal;
}
.alerta {
    margin-left: 5px;
    padding: 0.25em 0.4em;
    border-radius: 0.25rem;
    font-size: 75%;
    font-weight: 350;
    width: auto;
    border: 1px solid var(--tag-danger-border);
    background-color: var(--tag-danger-background);
    color: var(--tag-danger-text);
}
</style>
